var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrvejrsrumMadpakkehus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#746d51"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.474,10.734a.362.362,0,0,0,0-.723H9.936a.362.362,0,0,0,0,.723h.907v1.317h-2.6V8.946H10.03a.451.451,0,1,0,0-.9H5.561a.451.451,0,1,0,0,.9H7.344v3.105H4.652V10.734h.909a.362.362,0,0,0,0-.723H3.023a.362.362,0,0,0,0,.723h.908v1.317H3.07a.361.361,0,0,0,0,.722h9.4a.361.361,0,1,0,0-.722h-.908V10.734Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.093,5.323,8.027,2.286a.448.448,0,0,0-.463,0L2.5,5.323a.451.451,0,1,0,.463.773L7.8,3.2,12.63,6.1a.441.441,0,0,0,.231.064.451.451,0,0,0,.232-.837Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrvejrsrumMadpakkehus);
export default __webpack_public_path__ + "static/media/TØRVEJRSRUM-MADPAKKEHUS.2e297199e6e82fffd456c842b0926d00.svg";
export { ForwardRef as ReactComponent };